import { Atom } from 'jotai';
import { createErrorMessage, mqttLogger } from '@hooks/mqtt/utils';
import { MqttMessage } from '../types';

export enum SubscriptionEvent {
  Subscribe = 'subscribe',
  Unsubscribe = 'unsubscribe',
  AddSubscriber = 'add_subscriber',
  RemoveSubscriber = 'remove_subscriber',
  Error = 'error',
}

export function setDebugLabels(atoms: Record<string, Atom<unknown>>): void {
  Object.entries(atoms).forEach(([name, atom]) => {
    atom.debugLabel = name;
  });
}

export function handleSubscriptionError(
  topic: string,
  error: unknown,
  context: string,
): MqttMessage {
  mqttLogger.error(`${context} for topic ${topic}:`, error);
  return createErrorMessage(
    topic,
    error instanceof Error ? error : new Error(String(error)),
  );
}

export function logSubscriptionEvent(
  event: SubscriptionEvent,
  topic: string,
  details?: {
    subscriberId?: string;
    subscriberCount?: number;
    error?: unknown;
    message?: string;
  },
): void {
  const logMessage =
    details?.message ||
    `${event.replace('_', ' ')} ${topic}${details?.subscriberId ? ` (subscriber: ${details.subscriberId})` : ''}`;

  switch (event) {
    case SubscriptionEvent.Error:
      mqttLogger.error(logMessage, details?.error);
      break;
    case SubscriptionEvent.Subscribe:
    case SubscriptionEvent.Unsubscribe:
      mqttLogger.info(logMessage);
      break;
    default:
      mqttLogger.debug(logMessage);
  }

  if (details?.subscriberCount !== undefined) {
    mqttLogger.debug(
      `${topic} now has ${details.subscriberCount} subscriber(s)`,
    );
  }
}

export function createSubscriptionKey(
  topic: string,
  subscriberId: string,
): string {
  return `${topic}:${subscriberId}`;
}
